import React, { useState, useEffect } from 'react';
import ItemList from 'components/utils/ItemList';
import Item from 'components/utils/Item';
import OptionButton from 'components/chatapp/OptionButton';
import { SessionHistory } from 'types/session';
import { UserDetail } from 'types/user';

type ChatHistoryProps = {
  sessions: SessionHistory[];
  userDetail: UserDetail
  currentSessionId: string;
  setSessionId: (sessionId: string) => void;
  setSessionList: React.Dispatch<React.SetStateAction<SessionHistory[]>>;
  disable: boolean
};

const ChatHistory: React.FC<ChatHistoryProps> = ({
  userDetail,
  sessions = [],
  currentSessionId,
  setSessionId,
  setSessionList,
  disable
}) => {
  const [openItemId, setOpenItemId] = useState<string | null>(null);

  const isDisplayExport = userDetail.role !== "student"
  
  const handleDeleteSession = (id: string) => {
    setSessionList(prevSessions => prevSessions.filter(session => session.sessionId !== id));
    
    if (openItemId === id) {
      setOpenItemId(null);
    }
  };

  useEffect(() => {
    if (openItemId && !sessions.some(session => session.sessionId === openItemId)) {
      setOpenItemId(null);
    }
  }, [sessions, openItemId]);

  return (
    <>
      <ItemList
        title="Recent"
        maxHeight={sessions.length > 5 ? 'max-h-60' : ''} 
        overflowHidden={sessions.length <= 5}
        width='w-full md:w-[290px]'
      >
        {sessions.map(session => (
          <Item
            key={session.sessionId}
            itemId={session.sessionId}
            currentSelectId={currentSessionId}
            displayText={(session.sessionName !== "") && (session.sessionName !== session.sessionId) ? session.sessionName : session.userMessage}
            isOpen={openItemId == session.sessionId}
            setOpenItemId={setOpenItemId}
            setItemId={setSessionId}
            renderButtons={(itemId) => <OptionButton itemId={itemId} currentSelectId={currentSessionId} onDelete={handleDeleteSession} isDisplayExport={isDisplayExport} />}
            disable={disable}
          />
        ))}
      </ItemList>
    </>
  )
};

export default ChatHistory;